import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Login } from "../Pages/Login";
// import { LandingPage } from "../Pages/LandingPage";
import { LoginLandingPage } from "../Pages/LoginLanding";
import ProtectedRoute from "../RouterPath/protectedRoute"; // Import ProtectedRoute

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {
      }
    };

    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        {/* Public Routes - Without Layout (No Header) */}
        <Route path="/" element={<LoginLandingPage />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/landing" element={<LandingPage />} /> */}

        {/* Protected Routes - With Layout (Has Header) */}
        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          <Route element={<ProtectedRoute />}>
            {/* Protected routes can be added here when pages are implemented */}
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
